// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"toolbar_toolbar__3fQnA","space":"toolbar_space__1N-I-","about":"toolbar_about__2xFGQ"};